import React, { useState } from "react";
import { Button, FloatingLabel, Form } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiMessageSquare } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import { TbClubsFilled } from "react-icons/tb";
import member1 from "../assets/images/member1.svg";
import member2 from "../assets/images/member2.svg";
import member3 from "../assets/images/member3.svg";
import member4 from "../assets/images/member4.svg";
import { useAuth } from "../../src/context/AuthContext";
import { Modal } from 'react-bootstrap';
import { useNavigate } from "react-router-dom"; // Import useNavigate

const members = [
  {
    id: 1,
    name: "Esther Howard",
    email: "esther.howard@gmail.com",
    posts: "5.6k",
    polls: "44",
    clubs: "2",
    avatar: member1,
  },
  {
    id: 2,
    name: "Eleanor Pena",
    email: "eleanor.pena@gmail.com",
    posts: "20k",
    polls: "44",
    clubs: "6",
    avatar: member2,
  },
  {
    id: 3,
    name: "Marvin McKinney",
    email: "marvin.mckinney@gmail.com",
    posts: "90k",
    polls: "44",
    clubs: "4",
    avatar: member3,
  },
  {
    id: 4,
    name: "Kristin Watson",
    email: "kristin.watson@gmail.com",
    posts: "7.2k",
    polls: "44",
    clubs: "90",
    avatar: member4,
  },
];

const MemberList = ({ member, onDelete }) => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [email, setEmail] = useState("");
  const [menuOpen, setMenuOpen] = useState(null);
  const { isAuthenticated } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate(); // Initialize navigation
  // Handle Delete Button Click
  const handleDeleteClick = () => {
    setShowConfirm(true); // Show confirmation modal
  };

  // Handle Confirm Delete
  const confirmDelete = () => {
    if (typeof onDelete === "function") {
      onDelete(member.id); // Call the delete function
    } else {
      console.error("onDelete is not defined or not a function.");
    }
    setShowConfirm(false); // Close modal
    setMenuOpen(false); // Close menu
  };

  return (
    <div className="member-list-container">
      <h4>Invite a member</h4>
      {/* Invite Section */}
      {isAuthenticated && (
        <div className="invite-section">
          <FloatingLabel controlId="inviteEmail" label="Email address" className="invite-label">
            <Form.Control
              type="email"
              placeholder="Email address"
              className="invite-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FloatingLabel>
          <Button className="invite-btn">Invite</Button>
        </div>
      )}

      {/* Member List */}
      <div className="members-list">
        {members.map((member) => (
          <div
            key={member.id}
            className={`member-card ${selectedMember === member.id ? "selected" : ""}`}
            onClick={() => setSelectedMember(member.id)}
          >
            <img src={member.avatar} alt={member.name} className="member-avatar" />
            <div className="member-info">
              <h4>{member.name}</h4>
              <p>
                <span><FaSquarePollHorizontal />{member.posts} Posts & {member.polls} Polls</span>
                <span className="devider">•</span>
                <span><TbClubsFilled/>{member.clubs} Clubs</span>
              </p>
            </div>
            {isAuthenticated && (
              <div className="menu-container">
                <button
                  className="menu-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenuOpen(menuOpen === member.id ? null : member.id);
                  }}
                >
                  <BsThreeDotsVertical />
                </button>

                {/* Dropdown Menu */}
                {menuOpen === member.id && (
                  <div className="menu-dropdown">
                    <div className="menu-item" onClick={() => navigate("/messages")}>
                      <FiMessageSquare /> Message
                    </div>
                    <div className="menu-item delete" onClick={handleDeleteClick}>
                      <RiDeleteBin6Line /> Remove
                    </div>
                  </div>
                )}
              </div>
            )}
            
          </div>
        ))}
        {/* Confirmation Modal */}
        <Modal size="sm" show={showConfirm} onHide={() => setShowConfirm(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Confirm Remove</Modal.Title>
              </Modal.Header>
              <Modal.Body className="delete-modal-body">
                <p>Are you sure you want to Remove this member?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="link" onClick={() => setShowConfirm(false)}>
                  No
                </Button>
                <Button variant="primary" onClick={confirmDelete}>
                  Yes, Remove
                </Button>
              </Modal.Footer>
            </Modal>
      </div>
    </div>
  );
};

export default MemberList;
